import moment from 'moment';
import type { FC } from 'react';
import React from 'react';

import { GetFeedbackData } from '@/types/database/feedback';

import ImageElement from '../ImageElement';
import styles from './index.module.scss';

const FeedbackItem: FC<{
  showMessage: () => void;
  feedback: GetFeedbackData[number];
}> = ({ showMessage, feedback }) => {
  return (
    <div className={styles.feedbackItem}>
      <div className={styles.category}>
        <p className={styles.label}>類別</p>
        <span
          className={`${
            feedback.status === '未回覆'
              ? styles.status
              : styles.statusCompleted
          }`}
        >
          {feedback.status}
        </span>
        <p className={styles.content}>{feedback.type}</p>
      </div>
      <p className={styles.label}>標題</p>
      <p className={styles.title}>{feedback.title}</p>
      <p className={styles.label}>內容</p>
      <p className={styles.content}>{feedback.content}</p>
      {feedback.image && (
        <>
          <p className={styles.label}>圖片</p>
          <ImageElement image={feedback.image.path} />
        </>
      )}
      <p className={styles.createdTime}>{`建立時間：${moment(
        feedback.createdTime
      ).format('YYYY-MM-DD HH:mm:ss')}`}</p>
      <button className={styles.showMessage} onClick={showMessage}>
        查看回覆
      </button>
    </div>
  );
};

export default FeedbackItem;
